import Logo from "shared/Logo/Logo";
import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import React from "react";
import Icon from "shared/Logo/Icon";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: (CustomLink & { newtab?: boolean })[];
}

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "5",
    title: "Lokalai",
    menus: [
      {
        href: "https://business.lokalai.com/about",
        label: "About us",
        newtab: true,
      },
      { href: "#", label: "Customer Support" },
      { href: "#", label: "Blog" },
      { href: "#", label: "Sitemap" },
    ],
  },
  {
    id: "1",
    title: "For business",
    menus: [
      {
        href: "https://business.lokalai.com/",
        label: "List your business",
        newtab: true,
      },
      {
        href: "https://business.lokalai.com/register",
        label: "Why Lokalai?",
        newtab: true,
      },
      {
        href: "https://business.lokalai.com/price",
        label: "Pricing",
        newtab: true,
      },
      {
        href: "https://business.lokalai.com/contact",
        label: "Technical Support",
        newtab: true,
      },
      { href: "#", label: "Careers" },

      { href: "#", label: "Status" },
    ],
  },
  {
    id: "2",
    title: "Legal",
    menus: [
      { href: "#", label: "Privacy Policy" },
      { href: "#", label: "Terms of service" },
      { href: "#", label: "Terms of use" },
    ],
  },
  {
    id: "4",
    title: "Find us on social",
    menus: [
      // { href: "#", label: "Discussion Forums" },
      // { href: "#", label: "Code of Conduct" },
      // { href: "#", label: "Community Resources" },
      // { href: "#", label: "Contributing" },
      // { href: "#", label: "Concurrent Mode" },
    ],
  },
];

const Footer: React.FC = () => {
  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    const isLastColumn = index === widgetMenus.length - 1;

    return (
      <div key={index} className="text-sm">
        <h1 className=" text-neutral-700 dark:text-neutral-200 bg-white dark:bg-transparent dark:text-white">
          {menu.title}
        </h1>
        <ul className="mt-5 space-y-4">
          {menu.menus.map((item, index) => (
            <li key={index}>
              <a
                key={index}
                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
                href={item.href}
                target={item.newtab ? "_blank" : undefined}
                rel={item.newtab ? "noopener noreferrer" : undefined}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
        {/* Only show social icons in the last column */}
        {isLastColumn && (
          <div className="mt-6">
            <SocialsList1 className="flex items-center space-x-3 lg:space-x-0 lg:flex-col lg:space-y-2.5 lg:items-start" />
          </div>
        )}
      </div>
    );
  };

  const getCurrentYear = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    return currentYear;
  };

  return (
    <div className="nc-Footer  z-10 relative py-24 lg:py-28 border-t border-neutral-200 dark:border-neutral-700">
      <div className="container grid grid-cols-2 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-4 lg:grid-cols-5 lg:gap-x-10 ">
        <div className="grid grid-cols-4 gap-5 col-span-2 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
          <div className="col-span-1 md:col-span-1">
            <Logo />
          </div>
        </div>
        {widgetMenus.map(renderWidgetMenuItem)}
      </div>
      <div className="w-full mx-auto max-w-screen-xl p-4 mt-5 flex md:items-center justify-between ">
        <span className="text-sm text-gray-600 sm:text-center dark:text-gray-400">
          © {new Date().getFullYear()}{" "}
          <a href="https://lokalai.com/" className="hover:underline">
            Lokalai
          </a>
        </span>
        <span className="text-sm text-gray-600 sm:text-center dark:text-gray-400">
          {" "}
          All Rights Reserved.
        </span>
      </div>
    </div>
  );
};

export default Footer;
